module.exports = __webpack_public_path__ + "static/media/(DH)_MG_4704_-_bijuterias.3b15022e.jpg";